<template>
  <div>
    <BaseTitle :title="$t('menu.assignment_score')" :yearPeriode="titleData" />
    <div>
      <v-card>
        <div class="move-list">
          <div class="move-list-title pa-5">
            <div class="d-flex justify-space-between align-center">
              <h3>{{ $t('content.attempt') }} {{ $t('content.student') }}</h3>
            </div>
          </div>
          <div class="move-list-content">
            <ul>
              <li v-for="(data, idx) in dataAttempt" :key="data.studentId">
                <v-row>
                  <v-col class="mt-4" md="3">
                    {{ data.fullName }}
                  </v-col>
                  <v-col md="9">
                    <form-group :name="$t('content.attempt')" :validator="$v.dataAttempt.$each.$iter[idx].quizAssignmentStudentId">
                      <template slot-scope="{ attrs }">
                        <v-radio-group v-model="data.quizAssignmentStudentId">
                          <v-radio
                            v-for="radio in data.attempts"
                            v-bind="attrs"
                            :key="radio.quizAssignmentStudentId"
                            :label="
                              `${$t('content.attempt')} ${radio.attempt} | ${$t('menu.score')} ${radio.totalScore} | ${$t(
                                radio.complete ? 'content.complete' : 'content.incomplete'
                              )}`
                            "
                            color="secondary"
                            :value="radio.quizAssignmentStudentId"
                            class="compact-form"
                            @input="$v.dataAttempt.$each.$iter[idx].quizAssignmentStudentId.$touch()"
                            @blur="$v.dataAttempt.$each.$iter[idx].quizAssignmentStudentId.$touch()"
                          />
                        </v-radio-group>
                        <div v-if="attrs.errorMessages[0]" class="red--text">{{ attrs.errorMessages[0] }} {{ data.fullName }}</div>
                      </template>
                    </form-group>
                  </v-col>
                </v-row>
              </li>
              <div v-if="!dataAttempt.length" class="succ">
                <div class="succ-content">
                  <svg-icon icon="ic-nodata-mini" class="succ-featured" width="130" height="100" />
                  <h1 class="succ-heading">{{ $t('nodata_title') }}</h1>
                  <div class="succ-content mb-8">{{ $t('nodata_body') }}</div>
                </div>
              </div>
            </ul>
          </div>
        </div>
      </v-card>

      <div class="d-flex justify-end align-center mt-5">
        <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('back') }}</v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="dataAttempt.length === 0"
          class="btn-primary-custom"
          type="submit"
          @click="submitData = true"
        >
          {{ $t('submit') }}
        </v-btn>
      </div>
      <!-- Dialog submit -->
      <v-dialog v-model="submitData" persistent max-width="550">
        <v-card>
          <v-card-title class="headline">{{ $t('content.attempt_take_title') }} ?</v-card-title>
          <v-card-text>{{ $t('content.attempt_take_content') }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="submitData = false">{{ $t('back') }}</v-btn>
            <v-btn color="primary" :loading="loading" class="btn-primary-custom" type="submit" @click="submit">
              {{ $t('submit') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'TeacherAssignmentAttemptQuiz',
  components: {
    BaseTitle
  },
  computed: {
    ...mapGetters({
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    equal() {
      return '<';
    }
  },
  validations() {
    return {
      dataAttempt: {
        $each: {
          quizAssignmentStudentId: { required }
        }
      }
    };
  },
  data: () => ({
    submitData: false,
    loading: false,
    dialogPopUp: false,
    checkbox: false,
    radioGroup: '',
    answer: '',
    description: '',
    dataClass: '',
    dataAttempt: '',
    baseUrl: process.env.VUE_APP_BASE_URL,
    titleData: ''
  }),
  methods: {
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    getData() {
      const { assignmentId } = this.$route.params;
      this.$store
        .dispatch('Assignment/fetchAttemptQuiz', { assignmentId })
        .then(res => {
          res.forEach(data => (data.quizAssignmentStudentId = ''));
          this.dataAttempt = res;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    back() {
      if (!this.$route.params.classSectionId) {
        this.$router.push({ name: 'TeacherAssignmentDetail' });
      } else {
        this.$router.push({ name: 'TeacherAssignmentSectionDetail' });
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.loading = true;
      var assignmentId = this.$route.params.assignmentId;
      this.dataAttempt.forEach(form => {
        form.assignmentId = assignmentId;
      });
      var json = {
        attempts: this.dataAttempt
      };
      this.$store
        .dispatch('Assignment/submitAttemptQuiz', json)
        .then(() => {
          if (!this.$route.params.classSectionId) {
            this.$router.push({ name: 'TeacherAssignmentScoreQuiz' });
          } else {
            this.$router.push({ name: 'TeacherAssignmentSectionScoreQuiz' });
          }
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    }
  },
  created() {
    this.getData();
    this.getDataClass();
  }
};
</script>

<style lang="scss" scoped>
.compact-form {
  transform: scale(0.8);
  transform-origin: left;
}
.pointer {
  cursor: pointer;
}
.move-list {
  height: 100%;

  &-title {
    background: #00bf63;
    color: #fff;
    font-family: Montserrat;
    font-weight: 800;
    padding: 10px;
    width: 100%;
  }

  &-content {
    border: 1px solid #d8d8d8;
    padding: 10px;
    background: #fff;
    overflow: scroll;
    overflow-x: hidden;
    width: 100%;
    height: 100%;
    line-height: 2em;

    ul {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d8d8d8;
        padding: 10px 15px;
        align-items: center;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
.text-dropdown {
  cursor: pointer;
}
.succ {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;

  &-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    font-size: 12px;
  }

  &-featured {
    width: 100%;
    margin-bottom: 30px;
  }

  &-heading {
    color: #6d6d6d;
    font-family: Montserrat;
    font-weight: bold;
    font-size: 16px;
  }
}
</style>
